var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("DigitizingController",
    ["$rootScope", "$scope", "$window", "digitizingService",
        function ($rootscope, $scope, $window, digitizingService) {

            $scope.windowWidth = $window.innerWidth;
            
            //#region Cart Related
            $scope.AddCDToCart = function () {
                digitizingService.addDigitizingItemToCart()
                    .then(function (response) {
                        if (response && response.data && response.data.itemAdded) {
                            console.log("Item has been added");
                        }
                        else {
                            console.log("Item Failed to be added");
                        }
                    });
            };
            //#endregion
            
            $scope.getActiveCarousalLength = function(){
                if($scope.windowWidth > 991){
                    return 5;
                }
                else if($scope.windowWidth < 768){
                    return 1;
                }
                else{
                    return 4;
                }
            }

            $scope.getActiveSamples = function(){
                if($scope.getActiveCarousalLength() != $scope.samples.length){
                    $scope.activeIndex = $scope.getActiveCarousalLength()-1;
                    $scope.samples = $scope.samplesMaster.slice(0, $scope.getActiveCarousalLength());
                    $scope.$apply();
                }
            }

            $scope.onNavClick = function(navOption){
                switch (navOption){
                    case 'prev': 
                        if($scope.activeIndex - $scope.getActiveCarousalLength()+1 > 0){
                            $scope.activeIndex = $scope.activeIndex-1;
                            $scope.samples.pop();
                            $scope.samples.unshift(
                                $scope.samplesMaster[$scope.activeIndex - $scope.getActiveCarousalLength()+1]
                            );
                        }
                        break;
                    default:
                        if($scope.activeIndex < $scope.samplesMaster.length-1){
                            $scope.activeIndex = $scope.activeIndex+1;
                            $scope.samples.splice(0, 1);
                            $scope.samples.push($scope.samplesMaster[$scope.activeIndex]);
                        }
                        break;
                }
            }

            angular.element($window).bind('resize', function(){
                $scope.windowWidth = $window.innerWidth;
                $scope.getActiveSamples();
            }); 

            $scope.getCDContent = function(){
                digitizingService.getCDContent().then(
                    function(response){
                        if(response){
                            $scope.prices = response.data.prices;
                            $scope.reviews = response.data.reviews;
                            $scope.samplesMaster = response.data.samples;
                            $scope.services = response.data.services;
                            $scope.samples = angular.copy($scope.samplesMaster.slice(0, $scope.getActiveCarousalLength()));
                            $scope.activeIndex = $scope.getActiveCarousalLength()-1;
                            $scope.getActiveSamples();
                        }
                    }
                )
            }
            $scope.getCDContent();
        }
    ]
);
